<app-modal header="Ocultar dados sensíveis" [isShow]="open" style="w-[min(960px,96vw)]" appendTo="body" (cancel)="cancel()">
  <p class="mb-4 text-sm text-neutral-600">Desfoque documentos, matrículas, caras ou outros dados que não devem ficar visíveis. A imagem tratada é a que fica pública. A original fica guardada à parte.</p>

  <div class="mb-4 flex flex-wrap items-center gap-2">
    <label class="flex items-center gap-2 text-sm text-neutral-600">
      Tamanho
      <input type="range" min="4" max="72" [(ngModel)]="brushSize" class="w-28">
    </label>
    <button type="button" (click)="undo()" class="rounded-full border border-neutral-300 px-4 py-2 text-sm text-neutral-700">Desfazer</button>
    <button type="button" (click)="reset()" class="rounded-full border border-neutral-300 px-4 py-2 text-sm text-neutral-700">Recomeçar</button>
  </div>

  <div class="overflow-auto rounded-xl bg-neutral-100 p-3">
    <canvas #canvas
            class="mx-auto block max-h-[60vh] max-w-full touch-none cursor-crosshair"
            (pointerdown)="onPointerDown($event)"
            (pointermove)="onPointerMove($event)"
            (pointerup)="onPointerUp()"
            (pointerleave)="onPointerUp()"></canvas>
  </div>

  <div class="mt-5 flex justify-end gap-3">
    <app-ae-button label="Cancelar" type="button" variant="plain" size="sm" (buttonClick)="cancel()"></app-ae-button>
    <app-ae-button label="Guardar imagem" type="button" variant="primary" size="sm" [loading]="saving" (buttonClick)="confirm()"></app-ae-button>
  </div>
</app-modal>
